var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteSignClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91 76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 75.317c24.089-2.116 36.133-18.147 36.133-48.095V0H0v36.133h13.55v3.784c0 11.963-4.517 19.246-13.55 21.85v13.55zm54.2 0c24.088-2.116 36.132-18.147 36.132-48.095V0H54.199v36.133h13.55v3.784c0 11.963-4.517 19.246-13.55 21.85v13.55z",
    fill: "#FFF",
    opacity: 0.55
  })));
}

export default SvgQuoteSignClose;